import PdfBuilderDataItemRow from "../../pdfBuilder/components/data/PdfBuilderDataItemRow";
import PdfGrid from "../../pdfBuilder/components/layout/PdfGrid";
import PdfSection from "../../pdfBuilder/components/layout/PdfSection";
import PdfSectionTitle from "../../pdfBuilder/components/typography/PdfSectionTitle";
import PdfPageBrandedSubmission from "../../pdfBuilder/pages/PdfPageBrandedSubmission";
import PdfBorrowerExperienceTable from "../../pdfBuilder/ui/common/PdfBorrowerExperienceTable";

const PdfPageBorrowerBackgroundExperience = ({ formData }) => {
  return (
    <PdfPageBrandedSubmission
      pageNumber={"2 of 6"}
      pageTitle="Background & Experience"
      submittedBy={`${formData.firstName} ${formData.lastName}`}
      submittedDate={formData?.submission_date}
    >
      <PdfSection>
        <PdfSectionTitle>Background Check</PdfSectionTitle>

        <PdfBuilderDataItemRow
          label="Felony Conviction:"
          value={formData.application_felony_conviction ? "Yes" : "No"}
        />
        <PdfBuilderDataItemRow
          label="Financial Fraud:"
          value={
            formData.application_financial_fraud_misdemeanor ? "Yes" : "No"
          }
        />
        <PdfBuilderDataItemRow
          label="Bankruptcy (last 5 years):"
          value={formData.bankruptcy_flag ? "Yes" : "No"}
        />
        <PdfBuilderDataItemRow
          label="First Time Homebuyer:"
          value={formData.firstTimeHomebuyer ? "Yes" : "No"}
        />
        <PdfBuilderDataItemRow
          label="Bankruptcy (last 5 years):"
          value={formData.bankruptcy_flag ? "Yes" : "No"}
        />

        <PdfBuilderDataItemRow
          label="First Time Homebuyer:"
          value={formData.firstTimeHomebuyer ? "Yes" : "No"}
        />

        <PdfBuilderDataItemRow
          label="Open Liens/Judgments:"
          value={formData.open_liens_judgments ? "Yes" : "No"}
        />

        {formData.housing_events && formData.housing_events.length > 0 && (
          <PdfBuilderDataItemRow
            label="Housing Events:"
            value={formData.housing_events.join(", ")}
          />
        )}
      </PdfSection>

      <PdfSection>
        <PdfSectionTitle>Investment Experience</PdfSectionTitle>
        <PdfBuilderDataItemRow
          label="Experience Summary:"
          value={formData.borrowerExperienceSummary}
        />

        <PdfBuilderDataItemRow
          label="Income Properties:"
          value={
            formData.hasExperienceWithIncomeProducingProperties ? "Yes" : "No"
          }
        />

        <PdfBuilderDataItemRow
          label="Fix & Flips:"
          value={formData.hasExperienceWithFixFlips ? "Yes" : "No"}
        />

        <PdfBuilderDataItemRow
          label="Ground Up Construction:"
          value={formData.hasExperienceWithGroundUpConstruction ? "Yes" : "No"}
        />

        <PdfGrid columns={3} gap={14}>
          {formData.ff_sold && (
            <PdfBorrowerExperienceTable
              data={formData.ff_sold}
              title="Fix & Flips Sold"
            />
          )}
          {formData.ff_retained_as_rental && (
            <PdfBorrowerExperienceTable
              data={formData.ff_retained_as_rental}
              title="Fix & Flips Retained as Rental"
            />
          )}
          {formData.guc_sold && (
            <PdfBorrowerExperienceTable
              data={formData.guc_sold}
              title="Ground Up Construction Sold"
            />
          )}
        </PdfGrid>
      </PdfSection>
    </PdfPageBrandedSubmission>
  );
};

export default PdfPageBorrowerBackgroundExperience;
